import { render, staticRenderFns } from "./InternalSupplierPage.vue?vue&type=template&id=6e140926&scoped=true&"
import script from "./InternalSupplierPage.vue?vue&type=script&lang=js&"
export * from "./InternalSupplierPage.vue?vue&type=script&lang=js&"
import style0 from "./InternalSupplierPage.vue?vue&type=style&index=0&id=6e140926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e140926",
  null
  
)

/* custom blocks */
import block0 from "./InternalSupplierPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VIcon,VTextField})
